{
  "SET_NEW_PASSWORD": {
    "TITLE": "تعيين كلمة مرور جديدة",
    "PASSWORD": {
      "LABEL": "كلمة المرور",
      "PLACEHOLDER": "كلمة المرور",
      "ERROR": "كلمة المرور قصيرة جداً."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "تأكيد كلمة المرور",
      "PLACEHOLDER": "تأكيد كلمة المرور",
      "ERROR": "كلمة المرور غير متطابقة."
    },
    "API": {
      "SUCCESS_MESSAGE": "تم تغيير كلمة المرور بنجاح.",
      "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "CAPTCHA": {
      "ERROR": "انتهت صلاحية التحقق. الرجاء حل كلمة التحقق مرة أخرى."
    },
    "SUBMIT": "إرسال"
  }
}
